<template>
    <div class="container" id="loader-container" v-show="show">
        <img class="loader-image" src="@/../static/images/loader-blue.gif" alt="loader" />
    </div>
</template>

<script setup>
// Define component options
defineOptions({
    name: 'Loader'
});

// Define props
defineProps({
    show: { type: Boolean, required: true }
});
</script>
<style scoped>
.container {
    display: flex;
    position: absolute;
    width: 100%;
    height: 100%;
    background: #fff;
    opacity: .8;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}
.loader-image {
    width: 50px;
    height: 50px;
}
</style>

